import { Immutable } from "immer";
import React from "react";
import { formatDistanceWithSuffix } from "tsi-common-react/src/apps/retail/helpers";
import { RetailStore } from "tsi-common-react/src/models/location";
import {
    formatFullAddress,
    formatPhoneNumber,
} from "tsi-common-react/src/utils/format";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { HolidayHoursSummary } from "../HolidayHoursSummary";
import { CMSFlagshipStorePage } from "../models";
import { getTodayHours } from "../utils";

type IProps = Immutable<{
    cmsProps: CMSFlagshipStorePage;
    store: RetailStore;
}>;

export const CMSFlagshipStore = (props: IProps): React.ReactNode => {
    const staticURL = useStaticURL();
    // Convert distance from meters to miles
    const phoneInUSFormat = props.store.phone
        ? formatPhoneNumber(props.store.phone)
        : "";
    return (
        <div className="pdp-modal-tpstore pdp-modal__block">
            <h5 className="pdp-modal__subtitle">
                {t`Your Closest Tempur-Pedic Store`}
            </h5>
            <div className="pdp-modal-tpstore__content-container">
                <div className="pdp-modal-tpstore__img-wrapper">
                    {props.cmsProps.storefront_thumbnail && (
                        <img
                            className="pdp-modal-tpstore__img responsive-img"
                            src={`${staticURL}img/retail-locator/tp-store-tile.jpg`}
                            alt={t`${props.cmsProps.title} Storefront`}
                            loading="lazy"
                            decoding="async"
                        />
                    )}
                    <div className="pdp-modal-tpstore__miles">
                        {props.store.distance &&
                            formatDistanceWithSuffix(props.store.distance)}
                    </div>
                </div>
                <div className="pdp-modal-tpstore__info">
                    <h4 className="pdp-modal-tpstore__name">
                        {props.cmsProps.title}
                    </h4>
                    <div className="pdp-modal-tpstore__address">
                        <div>
                            <img
                                src={`${staticURL}img/retail-locator/location-icon.png`}
                                alt={t`Location Icon`}
                                loading="lazy"
                                decoding="async"
                            />
                            <span className="pdp-modal-tpstore__marker al-more-ways-to-buy-directions">
                                {formatFullAddress({
                                    address: props.store.address,
                                    address2: props.store.address2,
                                    city: props.store.city,
                                    state: props.store.state,
                                })}
                            </span>
                        </div>
                        {phoneInUSFormat && (
                            <div>
                                <img
                                    src={`${staticURL}img/retail-locator/phone-icon.png`}
                                    alt={t`Phone Icon`}
                                    loading="lazy"
                                    decoding="async"
                                />
                                <a
                                    href={`tel:${props.store.phone}`}
                                    className="pdp-modal-tpstore__phone pdp-modal__link"
                                >
                                    {phoneInUSFormat}
                                </a>
                            </div>
                        )}
                        <div>
                            <img
                                src={`${staticURL}img/retail-locator/hours-icon.png`}
                                alt={t`Hours Icon`}
                                loading="lazy"
                                decoding="async"
                            />
                            <div className="pdp-modal-tpstore__time">
                                {t`Today: `}
                                {getTodayHours(props.cmsProps)}
                            </div>
                        </div>
                        <HolidayHoursSummary
                            className="pdp-modal-tpstore__holiday-hours"
                            lines={
                                props.cmsProps.upcoming_holiday_hours_summary
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
